export const DIALOG_TYPES = {
  create: "create",
  edit: "edit",
  delete: "delete",
  error: "error"
};

export const ACCOUNT_EDITOR_ERRORS = {
  duplicate: "Account name already exists, please choose a different name.",
  general: "Attempt failed, please try again."
};

export const ERROR_DIALOG = {
  title: "Something went wrong",
  buttonText: "Back"
};

export const CREATE_DIALOG = {
  title: "Create new account",
  subtitle: "Please enter the following details to create a new account.",
  buttonText: "Create"
};

export const EDIT_DIALOG = {
  title: "Account settings",
  subtitle: "You are about to make some changes to account $accountName.",
  buttonText: "Submit"
};

export const DELETE_DIALOG = {
  title: "Delete selected account",
  subtitle: "Are you sure you want to delete the account $accountName?",
  buttonText: "Delete"
};

export const CONFIRMATION_DIALOG = {
  title:
    "Are you sure you want to submit the changes you made to the account $accountName?",
  buttonText: "Submit changes"
};

export const DIALOG_HELPER_TEXTS = {
  accountName: "Please enter a valid account name.",
  accountId: "Account ids must be in kebab-case. Please enter a valid account id.",
  ipAddress: "Please enter a valid IP address (e.g. 192.168.1.1 or 10.0.0.0/24).",
  salesforceAccountId: "Salesforce Account ID must be 15-18 alphanumeric characters."
};

export const ACCOUNT_TYPES = {
  CUSTOMER: "customer",
  INTERNAL: "internal"
};

export const ACCOUNT_TYPE_OPTIONS = [
  { key: ACCOUNT_TYPES.CUSTOMER, display_key: "Customer" },
  { key: ACCOUNT_TYPES.INTERNAL, display_key: "Internal" }
];

export const DEFAULT_ACCOUNT_TYPE = ACCOUNT_TYPES.CUSTOMER;

